import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateGmailIsSendOnly = mutatorAction('updateGmailIsSendOnly', function (isSendOnly) {
    var store = connectedAccountsStore();
    store.connectGmailState.isSendOnly = isSendOnly;
});
//# sourceMappingURL=updateGmailIsSendOnly.js.map